// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@stoneage/Overrides/Pages/Header";
import { css } from "styled-components";
import { getProp } from "@insite/mobius/utilities";
import { color, hideElement, layoutContainer, xScreen } from "@stoneage/XDL/Utilities";
import { DivWrapper } from "@stoneage/XDL/constants";

headerStyles.page = {
    fullWidth: [true, true, true, true, true],
    css: css`
        &&& {
            position: sticky;
        }
        top: 0;
        background: ${color("common.white")};
        z-index: ${getProp("theme.zIndex.header")};
    `,
};

headerStyles.container = {
    css: css`
        border-top: 1px solid ${color("common.ui6")};
        border-bottom: 1px solid ${color("common.ui6")};
        background-color: ${color("common.ui4")};
        & > ${DivWrapper} {
            ${layoutContainer}
        }

        ${xScreen("lt", "md")} {
            border-top: 0;
            border-bottom: 0;
            background-color: transparent;
        }
    `,
};
